import { jsxs as x, jsx as t, Fragment as W } from "react/jsx-runtime";
import * as c from "react";
import { forwardRef as m, useRef as $, useImperativeHandle as P, useMemo as g, useState as ee, cloneElement as te, isValidElement as re, memo as ne } from "react";
import { c as p } from "./tw-cn-mXgPecoF.mjs";
import { c as R } from "./index.js-Cr0Rsuyz.mjs";
import { u as le } from "./use-focus-BGKOEgog.mjs";
import { I as q } from "./icon-button-UFwDzoPr.mjs";
import { c as O } from "./index-BpNK5r1N.mjs";
function ae(e, r) {
  return /* @__PURE__ */ c.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: r
  }, e), /* @__PURE__ */ c.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25m0 10.803 3.074 3.073q.207.209.522.213a.7.7 0 0 0 .531-.213.72.72 0 0 0 .218-.527.72.72 0 0 0-.218-.526l-3.073-3.074 3.073-3.073a.73.73 0 0 0 .213-.522.7.7 0 0 0-.213-.531.72.72 0 0 0-.526-.218.72.72 0 0 0-.527.218L12 10.946 8.927 7.873a.73.73 0 0 0-.522-.213.7.7 0 0 0-.531.213.72.72 0 0 0-.218.526q0 .31.218.527L10.947 12l-3.073 3.074a.72.72 0 0 0-.213.522.7.7 0 0 0 .213.531q.216.218.526.218a.72.72 0 0 0 .527-.218z",
    clipRule: "evenodd"
  }));
}
var ie = R(/* @__PURE__ */ m(ae));
function se(e, r) {
  return /* @__PURE__ */ c.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: r
  }, e), /* @__PURE__ */ c.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.339 4.722a.75.75 0 0 0-1.061-1.06L3.661 20.277a.75.75 0 1 0 1.06 1.06l3.46-3.459c1.223.44 2.524.683 3.819.683 4.275 0 8.616-2.663 10.012-6.21a2.24 2.24 0 0 0 0-1.64c-.562-1.43-1.602-2.715-2.923-3.74zm-3.32 3.32-2.02 2.019a4.25 4.25 0 0 1-5.44 5.44l-1.187 1.188a9.7 9.7 0 0 0 2.628.373c3.768 0 7.483-2.38 8.616-5.26a.74.74 0 0 0 0-.542c-.475-1.206-1.403-2.325-2.598-3.218",
    clipRule: "evenodd"
  }), /* @__PURE__ */ c.createElement("path", {
    fill: "currentColor",
    d: "M15.965 5.237A11.4 11.4 0 0 0 12 4.5c-4.276 0-8.616 2.663-10.012 6.211a2.24 2.24 0 0 0 0 1.64c.578 1.47 1.661 2.788 3.036 3.827l1.073-1.073c-1.25-.906-2.224-2.058-2.714-3.303a.74.74 0 0 1 0-.542C4.517 8.381 8.232 6 12 6c.944 0 1.885.15 2.784.42z"
  }), /* @__PURE__ */ c.createElement("path", {
    fill: "currentColor",
    d: "M13.63 7.573a4.25 4.25 0 0 0-5.556 5.556l1.208-1.208a2.75 2.75 0 0 1 3.139-3.139z"
  }));
}
var oe = R(/* @__PURE__ */ m(se));
function ue(e, r) {
  return /* @__PURE__ */ c.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: r
  }, e), /* @__PURE__ */ c.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 7.25a4.25 4.25 0 1 0 0 8.5 4.25 4.25 0 0 0 0-8.5M9.25 11.5a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0",
    clipRule: "evenodd"
  }), /* @__PURE__ */ c.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 4.5c-4.276 0-8.616 2.663-10.012 6.211a2.24 2.24 0 0 0 0 1.64C3.384 15.9 7.724 18.562 12 18.562c4.275 0 8.616-2.663 10.012-6.21a2.24 2.24 0 0 0 0-1.64C20.616 7.162 16.275 4.5 12 4.5m-8.617 6.76C4.517 8.382 8.232 6 12 6s7.483 2.381 8.616 5.26a.74.74 0 0 1 0 .542c-1.133 2.88-4.848 5.26-8.616 5.26s-7.483-2.38-8.617-5.26a.74.74 0 0 1 0-.541",
    clipRule: "evenodd"
  }));
}
var ce = R(/* @__PURE__ */ m(ue));
const pe = ["default", "large"], de = O(["border border-solid relative flex items-center rounded-8 py-4 px-16"], {
  variants: {
    mobileSize: {
      default: "min-h-44",
      large: "min-h-56"
    },
    pcSize: {
      default: "pc:min-h-44",
      large: "pc:min-h-56"
    },
    isFocused: {
      true: "border-2 px-15",
      false: ""
    },
    disabled: {
      true: "bg-fill-neutral-weak",
      false: "bg-static-white"
    },
    isShowRightIconButton: {
      true: "",
      false: ""
    }
  },
  compoundVariants: [
    ...pe.flatMap((e) => [
      {
        isFocused: !1,
        mobileSize: e,
        isShowRightIconButton: !0,
        className: e === "default" ? "pr-8" : "pr-10"
      },
      {
        isFocused: !0,
        mobileSize: e,
        isShowRightIconButton: !0,
        className: e === "default" ? "pr-7" : "pr-9"
      },
      {
        isFocused: !1,
        pcSize: e,
        isShowRightIconButton: !0,
        className: e === "default" ? "pc:pr-8" : "pc:pr-10"
      },
      {
        isFocused: !0,
        pcSize: e,
        isShowRightIconButton: !0,
        className: e === "default" ? "pc:pr-7" : "pc:pr-9"
      }
    ])
  ],
  defaultVariants: {
    mobileSize: "default",
    pcSize: "default",
    isShowRightIconButton: !1,
    isFocused: !1
  }
}), fe = O(
  [
    "size-full placeholder:text-text-neutral-medium text-text-neutral-main disabled:text-interaction-neutral-disable-main disabled:placeholder:text-interaction-neutral-disable-main disabled:bg-fill-neutral-weak",
    // number 타입 input의 화살표 숨김
    "[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
  ],
  {
    variants: {
      mobileSize: {
        default: "typography-subtitle-16-regular",
        large: "typography-subtitle-18-regular"
      },
      pcSize: {
        default: "pc:typography-subtitle-16-regular",
        large: "pc:typography-subtitle-18-regular"
      }
    },
    defaultVariants: {
      mobileSize: "default",
      pcSize: "default"
    }
  }
), me = (e) => re(e) && e.type === "button", he = ({ children: e }) => me(e) ? te(e, { tabIndex: -1 }) : e, A = m(
  ({
    id: e,
    type: r = "text",
    value: n,
    disabled: a,
    onChange: s,
    onBlur: o,
    hasError: u = !1,
    placeholder: h,
    mobileSize: d = "default",
    pcSize: f = "default",
    rightTextButton: v,
    onClearCallback: y,
    onPasswordToggleCallback: S,
    showPasswordVisibleButton: E,
    showClearButton: D = !1,
    inputWrapperClassName: H,
    inputClassName: M,
    suffix: B,
    ...k
  }, G) => {
    var L, T;
    const i = $(null), { isFocused: I } = le(i);
    P(G, () => i.current);
    const z = g(() => d === "default" ? "small" : "medium", [d]), V = g(() => f === "default" ? "small" : "medium", [f]), [w, J] = ee(!1), K = de({
      disabled: a,
      mobileSize: d,
      pcSize: f,
      isFocused: I,
      isShowRightIconButton: !!(D || E)
    }), N = fe({ mobileSize: d, pcSize: f }), Q = g(() => a ? "border-line-neutral-weak3" : u ? "border-line-danger-main caret-text-danger-main" : I ? "border-line-neutral-main" : "border-line-neutral-weak3", [a, u, I]), U = (l) => {
      o == null || o(l);
    }, X = (l) => {
      l.preventDefault();
      const b = i.current;
      b && (b.value = "", j(), s && s({
        target: b,
        currentTarget: b
      })), y == null || y();
    }, j = () => {
      if (i.current) {
        const l = i.current.value.length || (n == null ? void 0 : n.toString().length) || 0;
        window.setTimeout(() => {
          i.current && i.current.setSelectionRange(l, l);
        }, 0), i.current.focus();
      }
    }, Y = () => {
      J(!w), j(), S == null || S();
    }, Z = (l) => {
      s == null || s(l);
    }, _ = g(() => r === "password" ? w ? "text" : "password" : r, [r, w]);
    return /* @__PURE__ */ x("div", { className: p(K, Q, H), children: [
      /* @__PURE__ */ t(
        "input",
        {
          className: p(N, M),
          disabled: a,
          id: e,
          onBlur: U,
          onChange: Z,
          placeholder: h,
          ref: i,
          type: _,
          value: n,
          ...k
        }
      ),
      B && (n || (L = i.current) != null && L.value) ? /* @__PURE__ */ x("div", { className: "pointer-events-none absolute left-0 top-0 flex h-full items-center", children: [
        /* @__PURE__ */ t("span", { className: p(N, M, "invisible"), children: n }),
        /* @__PURE__ */ t("span", { className: p(N, "text-text-tertiary ml-22 flex items-center"), children: B })
      ] }) : null,
      a ? null : /* @__PURE__ */ t(W, { children: v ? /* @__PURE__ */ t(he, { children: /* @__PURE__ */ t("div", { className: "pl-8", children: v }) }) : (n || ((T = i.current) == null ? void 0 : T.value)) && /* @__PURE__ */ x(W, { children: [
        D ? /* @__PURE__ */ t(
          q,
          {
            icon: /* @__PURE__ */ t(ie, {}),
            onClick: X,
            onMouseDown: (l) => {
              l.preventDefault();
            },
            size: { mobile: z, pc: V },
            tabIndex: -1,
            theme: "ghost"
          }
        ) : null,
        r === "password" && E ? /* @__PURE__ */ t(
          q,
          {
            icon: w ? /* @__PURE__ */ t(ce, {}) : /* @__PURE__ */ t(oe, {}),
            onClick: Y,
            onMouseDown: (l) => {
              l.preventDefault();
            },
            size: { mobile: z, pc: V },
            tabIndex: -1,
            theme: "ghost"
          }
        ) : null
      ] }) })
    ] });
  }
);
A.displayName = "NDS.Input";
const C = m(({ children: e, ...r }, n) => /* @__PURE__ */ t("label", { ref: n, ...r, className: "flex-start flex", children: typeof e == "string" ? /* @__PURE__ */ t("span", { className: "text-text-neutral-main typography-body-13-regular", children: e }) : e }));
C.displayName = "NDS.Label";
const F = ({ leftContent: e, rightContent: r, hasError: n, disabled: a }) => {
  const s = g(() => a ? "text-interaction-neutral-disable-main" : n ? "text-text-danger-main" : "text-text-neutral-main", [a, n]), o = (u, h) => typeof u == "string" ? /* @__PURE__ */ t("span", { className: h, children: u }) : u;
  return /* @__PURE__ */ x("div", { className: "flex w-full justify-between px-16 text-left", children: [
    e ? /* @__PURE__ */ t("div", { className: "mr-8", children: o(e, p("line-clamp-2 typography-body-12-regular-multiline", s)) }) : null,
    r ? /* @__PURE__ */ t("div", { className: "ml-auto", children: o(r, p("whitespace-nowrap text-text-neutral-main typography-body-12-regular")) }) : null
  ] });
};
F.displayName = "NDS.Support";
ne(F);
const ge = m(
  ({
    className: e,
    id: r,
    label: n,
    supportLeftContent: a,
    supportRightContent: s,
    hasError: o = !1,
    disabled: u = !1,
    inputRef: h,
    suffix: d,
    ...f
  }, v) => /* @__PURE__ */ x("div", { className: p("flex w-full flex-col gap-8", e), ref: v, children: [
    n ? /* @__PURE__ */ t(C, { htmlFor: r, children: n }) : null,
    /* @__PURE__ */ t(A, { disabled: u, hasError: o, id: r, ref: h, suffix: d, ...f }),
    a || s ? /* @__PURE__ */ t(
      F,
      {
        disabled: u,
        hasError: o,
        leftContent: a,
        rightContent: s
      }
    ) : null
  ] })
);
ge.displayName = "NDS.TextField";
export {
  ge as T
};
